import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

const DicomStart = () => {
  useEffect(() => {
    // Redirect to OHIF index.html that you built into public/ohif
    window.location.href = "/ohif/index.html";
  }, []);

  return <div>Loading OHIF Viewer...</div>;
};

export default DicomStart;
